export default function InfoIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21Z"
        fill="#191A19"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 9C13.3284 9 14 8.32843 14 7.5C14 6.67157 13.3284 6 12.5 6C11.6716 6 11 6.67157 11 7.5C11 8.32843 11.6716 9 12.5 9ZM10.2047 10.8124L14 10.5L12.2864 15.8541C12.1728 16.4149 12.3328 16.7332 12.7728 16.7332C13.0832 16.7332 13.5504 16.6178 13.8704 16.3275L13.7296 17.0136C13.2704 17.5843 12.2576 18 11.3856 18C10.2607 18 9.78232 17.3039 10.0927 15.8244L11.2543 12.3496C11.3567 11.8664 11.2639 11.6915 10.7935 11.576L10.0735 11.4391L10.2047 10.8124Z"
        fill="white"
      />
    </svg>
  );
}
